<template>
	<main class="linha singleDuvida">
		<div class="container">
			<div v-if="loaded">
				<h2>
					{{ duvida.titulo }}
					<small
						>Categoria: <router-link :to="'/duvidas/' + categoria.slug">{{ categoria.nome }}</router-link></small
					>
				</h2>
				<div class="richText vollkorn" v-html="convertVimeoLinksToIframes(duvida.texto)"></div>

				<button @click="voltar" class="btnVoltar"><i class="fas fa-arrow-left"></i> Voltar</button>
			</div>
			<div class="loading" v-else>
				<!-- <img src="@/assets/loading.gif" alt="loading" /> -->
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'duvidas',
	methods: {
		voltar() {
			this.$router.go(-1);
		},
		getVimeoId(vimeoLink) {
			let arr = vimeoLink.split('/');

			if (arr.length > 4) {
				return arr[arr.length - 2];
			} else {
				return arr[arr.length - 1];
			}
		},
		convertVimeoLinksToIframes(articleBody) {
			const regExVimeo = /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:.*)?(\d*)/;
			let newArticleBody;
			let mat = articleBody.match(regExVimeo);

			if (!mat) return articleBody;

			let vimLink = mat[0].split('<')[0];

			newArticleBody = articleBody.replace(vimLink, `<div class="iframeContainerArtigo"><iframe src="https://player.vimeo.com/video/${this.getVimeoId(vimLink)}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen ></iframe></div>`);

			return newArticleBody;
		},
	},
	computed: {
		categoria() {
			let c = this.categorias.find((categoria) => categoria.slug === this.$route.params.categoria);
			return c;
		},
		categorias() {
			return this.$store.getters.categorias;
		},
		duvida() {
			let d = this.$store.getters.duvidas[this.$route.params.categoria].find((duvida) => duvida.slug === this.$route.params.slug);
			return d;
		},
		loaded() {
			return this.$store.getters.duvidasLoaded;
		},
	},
	beforeCreate() {
		this.$store.dispatch('changeHome', false);
	},
};
</script>

<style lang="scss">
@import './../assets/sass/duvidas.scss';
</style>
